import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertintoInt'
})
export class ConvertintoIntPipe implements PipeTransform {

  transform(value: any, args?: any): any {
  
    if(value){
      return parseInt(value);
    }else{
      return 0;
    }
    
  }

}
